var link_viewer_default = {
  "fontElementMap": "XuPcc",
  "link": "Y2xcL",
  "linkInEditor": "tS0F3",
  "linkInViewer": "uFqDN",
  "toolbarUrlContainer": "fqe34",
  "toolbarUrl": "fmehm",
  "toolbarUrlAnchor": "l-vhu"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
